import { FC, ReactNode } from 'react';

import { Card, Flex } from 'antd';

import { isNullOrEmpty } from '@/utils';

import styles from './InfoCard.module.scss';

type Props = {
	title: ReactNode;
	value: ReactNode;
};

export const InfoCard: FC<Props> = ({ title, value }) => {
	return (
		<Card className={styles.card} variant="borderless">
			<Flex vertical justify="space-between" gap={16}>
				<div className={styles.title}>{title}</div>
				<div className={styles.value}>{isNullOrEmpty(value) ? '—' : value}</div>
			</Flex>
		</Card>
	);
};
